import EventCard from "@/components/base/EventCard";
import SectionHeading from "@/components/base/SectionHeading";
import { Link } from "react-router-dom";
import { events } from "@/mocks/events";

export default function LatestSection() {
  const latest = [...events].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 4);
  const hot = [...events].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <section className="w-full bg-background-100" aria-label="最新档案与热议榜">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_320px] lg:gap-12">
          <div>
            <SectionHeading
              eyebrow="LATEST"
              title="最新补充的档案"
              description="每一篇都在事件落定后重新校对过，补充了后续进展与最新的公开回应。"
            />
            <div className="mt-8 space-y-5">
              {latest.map((event) => (
                <EventCard key={event.id} event={event} variant="list" />
              ))}
            </div>
          </div>

          <aside className="lg:sticky lg:top-28 lg:self-start" aria-label="本周热议榜">
            <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <div className="flex items-center justify-between">
                <h2 className="font-heading text-base font-bold text-foreground-950">
                  <i className="ri-fire-line mr-1.5 text-primary-500" />
                  本周热议榜
                </h2>
                <span className="text-xs text-foreground-400">按热度</span>
              </div>
              <div className="mt-3">
                {hot.map((event) => (
                  <EventCard key={event.id} event={event} variant="compact" />
                ))}
              </div>
            </div>

            <div className="mt-5 rounded-lg bg-primary-500 p-5 text-background-50">
              <i className="ri-bookmark-3-line text-2xl text-accent-300" />
              <h2 className="mt-3 font-heading text-lg font-bold">需要补哪一段？</h2>
              <p className="mt-2 text-sm leading-relaxed text-background-100">
                找不到你想回顾的事件，可以把关键词或线索通过反馈表告诉我们，编辑会优先安排整理。
              </p>
              <Link
                to="/about#feedback"
                className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
              >
                去写一条线索
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}